// extracted by mini-css-extract-plugin
export default {"container":"HeadingBelowNumber_container__jpiPS","heading":"HeadingBelowNumber_heading__kZ12M","number":"HeadingBelowNumber_number__xfPte"};